import { render, staticRenderFns } from "./CustomerTransactionDetailsPopover.vue?vue&type=template&id=ac5dd682"
import script from "./CustomerTransactionDetailsPopover.vue?vue&type=script&lang=js"
export * from "./CustomerTransactionDetailsPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports